<template>
  <div>
    <bulk-record-import-modal
      ref="importModal"
      :notify-on-import="false"
    />
    <bulk-record-operations-list
      ref="notificacaoList"
      :carregar="carregar"
      :colunas="colunasListagem"
      :filtros="filtrosPrincipais"
      :mostrar-remover-lote="false"
      :permissao-delete-props="false"
      :editar="() => {}"
      :novo="novaImportacao"
      :remover="remover"
      :info="info"
    >
      <template #botao-editar>
        <span />
      </template>
      <template #botao-remover>
        <span />
      </template>
      <template #botao-adicional="{ props }">
        <b-button
          v-if="props.row.status === 'ErroProcessamento'"
          variant="info-outline"
          class="rounded-pill"
          @click="reprocessa(props.row)"
        >
          <feather-icon
            icon="RefreshCcwIcon"
            size="16"
          />
        </b-button>
        <b-btn
          v-if="props.row.status === 'ErroProcessamento' || props.row.status === 'AguardandoProcessamento'"
          v-b-tooltip.hover
          title="Cancelar"
          variant="none"
          class="btn-outline-danger btn-none  rounded-pill icone-acao"
          @click="cancelar(props.row)"
        >
          <feather-icon icon="XIcon" />
        </b-btn>
      </template>
    </bulk-record-operations-list>
  </div>
</template>
<script>
import api from '@/app-modulo/comuns/bulk-operations/shared/services/api'
import BulkRecordImportModal from './BulkRecordImportModal.vue'

export default {
  name: 'BulkOperationsList',
  components: {
    BulkRecordOperationsList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
    BulkRecordImportModal,
  },
  data() {
    return {
      colunasListagem: [
        { label: 'Recurso', field: 'tipoEntidade' },
        { label: 'status', field: 'status' },
        {
          label: 'Total de Registros',
          field: 'totalLinhas',
        },
      ],
      filtrosPrincipais: [],
      info: [],
    }
  },
  methods: {
    carregar(params) {
      return api.listHistoricoImportacoes(params)
    },
    cancelar(row) {
      this.$confirmar('Cancelar importação ? ', 'Esta ação não pode ser desfeita.', 'question', 'danger')
        .then(result => {
          if (result.value) {
            api.cancelarImportacao(row.id)
              .then(() => {
                this.$refs.notificacaoList.montarGrid()
                this.$toast.success('Importação cancelada com sucesso')
              })
              .catch(() => {
                this.$toast.error('Falha ao cancelar importação')
              })
          }
        })
    },
    novaImportacao() {
      this.$refs.importModal.showBulkImportModal()
    },
    reprocessa(row) {
      const ids = [row.id]
      api.reprocessar(ids).then(() => {
        this.$refs.notificacaoList.atualizar()
        this.$toast.success('Reprocessamento iniciado')
      }).catch(() => {
        this.$toast.error('Falha ao iniciar reprocessamento')
      })
    },
  },
}
</script>

<style scoped lang="scss">

</style>
